module.exports = __webpack_public_path__ + "img/body-2.d7b99e40.png";